import React, {useEffect, useState} from 'react';
import style from '../../css/Staff.module.css';
import { StaffContainer } from '../others-component/StaffContainer';
import { Typography, Paper, Divider, Box, IconButton, LinearProgress } from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { useSelector } from 'react-redux';
import { data } from '../../storeredux';
import { RefreshRounded } from '@mui/icons-material';

export default function Alumni(props) {
  const {setError} = props
  const alumniwd = useSelector(data)
  const [alumni,setAlumni] = useState([])
  const [nPage, setNPage] = useState(1)
  const [statePage,setStatePage] = useState(0)
  const [loading,setLoading] = useState(true)
  const AutoPlayPlayer = autoPlay(SwipeableViews)
  useEffect(() => {
    setLoading(true)
    var length = alumniwd['alumni'].length
    if (length > 0)
      setNPage(Math.ceil(length / 20))
    var st = statePage*20
    setAlumni(alumniwd['alumni'].slice(st,st+20))
    setLoading(false)
  },[alumniwd])

  const refresh = () => {
    setLoading(true)
    if (statePage+1 < nPage) {
      var st = (statePage+1)*20
      setAlumni(alumniwd['alumni'].slice(st,st+20))
      setStatePage(statePage+1)
    } else {
      setAlumni(alumniwd['alumni'].slice(0,20))
      setStatePage(0)
    }
    setLoading(false)
  }

  const visible = () => (
    <Paper elevation={10} style={{borderRadius:20,backgroundColor:'#ffb380',padding:'15px'}}>
      <Box justifyContent='center' alignItems='center' display='flex' style={{minHeight:'inherit',position:'relative'}}>
        <Typography variant='h5' style={{width:'100%', color:'#ff6600',textAlign:'center'}}>
          <b>No Data</b>
        </Typography>
      </Box>
    </Paper>
  )

  const loadinit = () => (
    <Paper elevation={10} style={{borderRadius:20,backgroundColor:'#595959',padding:'15px'}}>
      <Box justifyContent='center' alignItems='center' display='flex' style={{minHeight:'inherit',position:'relative'}} sx={{flexWrap:'wrap',color:'white'}}>
        <LinearProgress color="inherit" sx={{width:'100%'}}/>
        <Typography variant='h6' color="inherit">Loading</Typography>
      </Box>
    </Paper>
  )

  return(
    <Box id='Alumni' className={style.main}>
      <Box id='tit-osta' flexWrap='wrap' justifyContent='flex-end' alignItems='flex-end' display='flex'
          sx={{marginTop: '40px',width:'100%',marginBottom:'40px'}}>
        <Box sx={{backgroundColor:'#66ff66', top:'40px', left:'26vw',
          height: '50px', width: {xs:'30vw',md:'10vw'}, position:'relative', zIndex:-1}}/>
        <Box sx={{backgroundColor:'#66ff33', top: {xs:'80px',md:'-40px'},left:'18vw',
          height: '50px', width: {xs:'40vw',md:'10vw'}, position:'relative', zIndex:-1}}/>
        <Box style={{display:'flex'}}>
          <Typography variant='h3' style={{backgroundColor:'#33cc33'}}>
            <span className={style.titleMain}><b>Our Alumni</b></span>
          </Typography>
        </Box>
        <Divider style={{width:'100%',backgroundColor:'#33cc33',height:'5px'}}/>
      </Box>
      <Box id='alumni-con' className={style.submain}>
        {
          (alumni.length > 0)?
            <AutoPlayPlayer interval={15000} enableMouseEvents>
              {
                alumni.map((a,i) => (
                  <Box key={i} sx={{padding:'10px',display:'flex',alignItems:'center',justifyContent:'center'}}>
                    <StaffContainer
                      setError={setError}
                      name={a.name}
                      motivasi={a.motivasi}
                      departemen={a.departemen}
                      jabatan={a.jabatan}
                      image={(a.image && a.image.length !== 0)? (a.image):(null)}
                      facebook={a.facebook}
                      instagram={a.instagram}
                      tahun={a.tahun}
                      />
                  </Box>
                ))
              }
            </AutoPlayPlayer> :
          <Box justifyContent='center' alignItems='center' display='flex' className={style.card}>
            <Box style={{width:'100%',paddingLeft:'15px',paddingRight:'15px'}}>
              {
                (loading)?loadinit():visible()
              }
            </Box>
          </Box>
        }
      </Box>
      <Box className={style.submain} sx={{width:'100%',marginTop:'40px'}}>
        <IconButton color='primary' onClick={() => {refresh()}}>
          <RefreshRounded fontSize='large'/>
        </IconButton>
      </Box>
    </Box>
  )
}
